import { useEffect, useState } from 'react';
import {
  Descriptions,
  notification,
  Form,
  Space,
  Row,
  Col,
  Input,
  Typography,
  Card,
  Skeleton,
  Select,
} from 'antd';
import MESSAGES from '../../../enums/Messages';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import CustomButton from '../../../components/CustomButton';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { useParams, Link, useHistory } from 'react-router-dom';
import {
  getModificationDocuments,
  patchRegisterDocs,
} from '../../../api/module/mass_ctm_documents';
import '../Form/style.scss';
import ContractorsModal from '../MassForm/ContractorsModal';
import { ModificationModuleInnerSaveButton } from '../../../components/ModificationComponents';
import { TemplateInput } from '.';
import { catchException } from '../../../utils/helpers/helpers';

const { Title } = Typography;

const MassModificationDocuments = () => {
  var { modification_id } = useParams();
  const [form] = Form.useForm();

  const [docsTemplates, setDocsTemplates] = useState([]);
  const [dataInfo, setDataInfo] = useState();
  const [loadingFormRequest, setLoadingFormRequest] = useState(false);
  const navigate = useHistory();

  const breadcrumbItems = [
    {
      text: 'Módulo Modificaciones Contractuales',
      to: `${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}`,
    },
    {
      text: 'Formulario de Modificaciones Contractuales',
      to: `${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${dataInfo?.proyecto_id}/${modification_id}`,
    },
    {
      text: 'Modificación Documentos Adicionales',
    },
  ];

  useEffect(() => {
    async function fetchDataInfo() {
      setDataInfo();
      try {
        const response = await getModificationDocuments(modification_id);
        setDocsTemplates(response.data.templates);
        setDataInfo(response.data);
      } catch (error) {
        catchException(error);
      }
    }
    fetchDataInfo();
  }, [modification_id]);

  const sendFormModified = async (values) => {
    setLoadingFormRequest(true);

    try {
      await patchRegisterDocs(modification_id, values);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: 'Módulo actualizado correctamente.',
        duration: 2,
      });
      setLoadingFormRequest(false);
      setTimeout(() => {
        navigate.push(
          `${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${dataInfo.proyecto_id}/${modification_id}`,
        );
      }, MESSAGES.TIME);
    } catch (error) {
      setLoadingFormRequest(false);
      catchException(error);
    }
  };

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <div className="box-title">
        <Title className={'text-uppercase'} level={2}>
          MODIFICACIÓN DOCUMENTOS ADICIONALES
        </Title>
      </div>
      {dataInfo ? (
        <>
          <Descriptions
            layout="horizontal"
            column={1}
            bordered
            styles={{
              label: { maxWidth: '8rem' },
            }}
            className="fade-in"
          >
            <Descriptions.Item label="Cargo / Rol">
              <Row align="middle">
                <Col flex="auto">{dataInfo.cargo_nombre}</Col>
                <Col flex="0 0">
                  <ContractorsModal
                    initialValues={{ ...dataInfo, id: dataInfo.ctm_id }}
                  />
                </Col>
              </Row>
            </Descriptions.Item>
            <Descriptions.Item label="Identificador interno de la modificación masiva">
              {dataInfo.identificador_masivo}
            </Descriptions.Item>
          </Descriptions>
          <Card
            size={'small'}
            bordered={false}
            title={<Title level={3}>7. Documentos adicionales</Title>}
          >
            <p>Documentos complementarios VIGENTES</p>
            <Select
              mode="multiple"
              allowClear
              disabled
              value={dataInfo.current_documents.map(
                (item) => item.id_plantilla,
              )}
            >
              {dataInfo.current_documents.map((item) => (
                <Select.Option
                  key={`document-types-key-${item.id_plantilla}`}
                  value={item.id_plantilla}
                >
                  {item.codigo_plantilla ? `${item.codigo_plantilla} - ` : ''}
                  {item.nombre_plantilla}
                </Select.Option>
              ))}
            </Select>
          </Card>
          <Card
            size={'middle'}
            bordered={false}
            title={
              <Title level={4}>Documentos complementarios a solicitar</Title>
            }
          >
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              onFinish={sendFormModified}
              initialValues={{
                documentos_adicionales: dataInfo.docsModified,
                justificacion: dataInfo.justification,
              }}
            >
              <Form.Item
                name="documentos_adicionales"
                rules={[
                  {
                    required: true,
                    message: 'Seleccione el documento',
                  },
                ]}
              >
                <TemplateInput
                  pdfData={{
                    // person: dataInfo.contratista_id,
                    term: dataInfo.termino_id,
                    contract: dataInfo.contrato_id,
                    modification: dataInfo.id,
                  }}
                  disabled={loadingFormRequest}
                  dataSource={docsTemplates}
                  onUpdate={(record_id) => {
                    setDocsTemplates((s) =>
                      s.map((v) =>
                        v.curr_id === record_id
                          ? {
                              ...v,
                              curr_id: v.up_id,
                              up_id: undefined,
                              version: v.up_version,
                              up_version: undefined,
                            }
                          : v,
                      ),
                    );
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Justificación"
                name="justificacion"
                rules={[
                  {
                    required: true,
                    message: 'Ingresa la Justificación',
                  },
                ]}
              >
                <Input.TextArea allowClear />
              </Form.Item>

              <Space>
                <CustomButton
                  htmlType="button"
                  className={'back-button'}
                  type="default"
                  text={
                    <Link
                      to={`${INTERNAL_LINKS.CONTRACT_MASS_MODIFICATIONS}/${dataInfo.proyecto_id}/${modification_id}`}
                    >
                      Volver
                    </Link>
                  }
                />
                <ModificationModuleInnerSaveButton
                  onClick={() => form.submit()}
                  loading={loadingFormRequest}
                />
              </Space>
            </Form>
          </Card>
        </>
      ) : (
        <Skeleton active loading />
      )}
    </>
  );
};

export default MassModificationDocuments;
